export class SignatureMessages {

  public certificateCertification = 'signature.certificat.certification';
  public certificateDate = 'signature.certificat.date';
  public certificateLevel = 'signature.certificat.level';
  public certificateOid = 'signature.certificat.oid';
  public certificateStatus = 'signature.certificat.status';
  public certificateSupportType = 'signature.certificat.support_type';
  public certificateTitle = 'signature.certificat.title';
  public certificateUsage = 'signature.certificat.usage';
  public certificateValidity = 'signature.certificat.validity';
  public certificateNonEidasLevel = 'signature.certificat.non_eidas_level';
  public certificateRevocationDate = 'signature.certificat.revocation_date';

  public propertyDate = 'signature.property.date';
  public propertyFormatSignature = 'signature.property.format_signature';
  public propertyHour = 'signature.property.hour';
  public propertyInformation = 'signature.property.information';
  public propertyIntegrity = 'signature.property.integrity';
  public signatureLevel = 'signature.property.level';
  public propertyStatus = 'signature.property.status';
  public propertyTitle = 'signature.property.title';
  public propertyTransmitter = 'signature.property.transmitter';

  public signatureIdentifier = 'signature.signature.identifier';
  public signatureSignatory = 'signature.signature.signatory';
  public signatureTitle = 'signature.signature.title';
  public signatureTransmitter = 'signature.signature.transmitter';
  public signatureErrors = 'signature.signature.errors';

  public timesptampCertification = 'signature.timestamp.certification';
  public timesptampDate = 'signature.timestamp.date';
  public timesptampDateTS = 'signature.timestamp.date_TS';
  public timesptampIdentifier = 'signature.timestamp.identifier';
  public timesptampIntegrity = 'signature.timestamp.integrity';
  public timesptampLevel = 'signature.timestamp.level';
  public timesptampOid = 'signature.timestamp.oid';
  public timesptampSecurityLevel = 'signature.timestamp.security_level';
  public timesptampStatus = 'signature.timestamp.status';
  public timesptampSupportType = 'signature.timestamp.support_type';
  public timesptampTimeTS = 'signature.timestamp.time_TS';
  public timesptampTitle = 'signature.timestamp.title';
  public timesptampTitleCertificate = 'signature.timestamp.title_certificate';
  public timesptampUsage = 'signature.timestamp.usage';
  public timesptampValidity = 'signature.timestamp.validity';
  public ok = 'general.ok';

  constructor() {
  }
}
